import React from 'react';
import { waLink } from '../analytics';

function MaintenancePackages() {
  return (
    <section id="website-maintenance" className="maintenance-section">
        <div className="maintenance-section__inner">
          <div className="maintenance-section__header">
            <span className="maintenance-section__badge">Managed Website Care</span>
            <h2 className="maintenance-section__title">WEBSITE MAINTENANCE</h2>
            <p className="maintenance-section__subtitle">
              Website Anda dirawat tim ahli—aman, cepat, dan selalu siap mendukung bisnis berkembang tanpa repot urus teknis.
            </p>
          </div>

          <div className="maintenance-grid">
            {/* Basic Maintenance */}
            <div className="maintenance-card" style={{ '--accent-color': '#64748b' }}>
              <div className="maintenance-card__header">
                <div className="maintenance-card__icon-wrapper">
                  <div className="maintenance-card__icon">🔧</div>
                </div>
                <h3 className="maintenance-card__name">Essential Care</h3>
                <div className="maintenance-card__price">
                  <div className="maintenance-card__current-price">
                    <span className="maintenance-card__currency">Rp</span>
                    <span className="maintenance-card__amount">499.000</span>
                    <span className="maintenance-card__period">/ bulan</span>
                  </div>
                </div>
              </div>

              <div className="maintenance-card__features">
                <ul className="maintenance-card__features-list">
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Pembaruan minor & patch keamanan</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Cadangan data bulanan terjadwal</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Monitoring uptime & ketersediaan</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Audit performa & kecepatan loading</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Dukungan teknis via chat (jam operasional)</span>
                  </li>
                </ul>
              </div>

              <div className="maintenance-card__action">
                <a
                  href={waLink('Halo, saya ingin memilih paket Website Maintenance: Essential Care. Mohon info lebih lanjut.')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="maintenance-card__btn"
                >
                  <span className="maintenance-card__btn-text">Pilih Paket</span>
                  <svg className="maintenance-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Standard Maintenance - Most Popular */}
            <div className="maintenance-card maintenance-card--popular" style={{ '--accent-color': '#3b82f6' }}>
              <div className="maintenance-card__badge">
                <span className="maintenance-card__badge-icon">⭐</span>
                <span className="maintenance-card__badge-text">Paling Direkomendasikan</span>
              </div>
              
              <div className="maintenance-card__header">
                <div className="maintenance-card__icon-wrapper">
                  <div className="maintenance-card__icon">⚙️</div>
                </div>
                <h3 className="maintenance-card__name">Professional Care</h3>
                <div className="maintenance-card__price">
                  <div className="maintenance-card__current-price">
                    <span className="maintenance-card__currency">Rp</span>
                    <span className="maintenance-card__amount">999.000</span>
                    <span className="maintenance-card__period">/ bulan</span>
                  </div>
                </div>
              </div>

              <div className="maintenance-card__features">
                <ul className="maintenance-card__features-list">
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Pembaruan sistem & plugin rutin</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Backup mingguan otomatis</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Monitoring proaktif & alert dini</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Perbaikan bug & gangguan minor</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Penyesuaian konten ringan (teks & visual)</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Optimasi kecepatan & performa dasar</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Support prioritas via chat</span>
                  </li>
                </ul>
              </div>

              <div className="maintenance-card__action">
                <a
                  href={waLink('Halo, saya ingin memilih paket Website Maintenance: Professional Care. Mohon info lebih lanjut.')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="maintenance-card__btn maintenance-card__btn--primary"
                >
                  <span className="maintenance-card__btn-text">Pilih Paket</span>
                  <svg className="maintenance-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Full Support Maintenance */}
            <div className="maintenance-card" style={{ '--accent-color': '#8b5cf6' }}>
              <div className="maintenance-card__header">
                <div className="maintenance-card__icon-wrapper">
                  <div className="maintenance-card__icon">🛡️</div>
                </div>
                <h3 className="maintenance-card__name">Enterprise Care</h3>
                <div className="maintenance-card__price">
                  <div className="maintenance-card__current-price">
                    <span className="maintenance-card__currency">Rp</span>
                    <span className="maintenance-card__amount">1.999.000</span>
                    <span className="maintenance-card__period">/ bulan</span>
                  </div>
                </div>
              </div>

              <div className="maintenance-card__features">
                <ul className="maintenance-card__features-list">
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Perawatan website menyeluruh end-to-end</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Backup rutin & pemulihan data</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Monitoring keamanan & deteksi ancaman</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Technical support prioritas dedicated</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Perbaikan bug prioritas (respons cepat)</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Update konten berkala sesuai brief</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Optimasi performa berkelanjutan</span>
                  </li>
                  <li className="maintenance-card__feature">
                    <div className="maintenance-card__check-wrapper">
                      <svg className="maintenance-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5"/>
                      </svg>
                    </div>
                    <span>Konsultasi strategi pengembangan website</span>
                  </li>
                </ul>
              </div>

              <div className="maintenance-card__action">
                <a
                  href={waLink('Halo, saya ingin memilih paket Website Maintenance: Enterprise Care. Mohon info lebih lanjut.')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="maintenance-card__btn"
                >
                  <span className="maintenance-card__btn-text">Pilih Paket</span>
                  <svg className="maintenance-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Note Section */}
          <div className="maintenance-note">
            <div className="maintenance-note__content">
              <div className="maintenance-note__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 16v-4"/>
                  <path d="M12 8h.01"/>
                </svg>
              </div>
              <div className="maintenance-note__text">
                <p>
                  Investasi dapat disesuaikan dengan skala dan kompleksitas website Anda.
                  Untuk e-commerce, sistem booking, atau solusi custom—tim kami menyiapkan penawaran tailored.
                  Hemat lebih banyak dengan kontrak berlangganan 6 atau 12 bulan.
                </p>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}

export default MaintenancePackages;
